import React from 'react';
import PropTypes from 'prop-types';

import ContactTooltip from 'bundles/backoffice/contacts/contact_tooltip';

const BUYER_TENANT_ROLES = ['buyer', 'buyer_contact', 'client', 'tenant', 'tenant_contact'];
const SELLER_LANDLORD_ROLES = ['seller', 'seller_contact', 'owner_landlord', 'owner_representative', 'owner_user'];

export default function ContactRole({ deal, name }) {
  if (!deal?.contactRoles) {
    return null;
  }

  const contactRoleTypes = name == 'buyerTenant' ? BUYER_TENANT_ROLES : SELLER_LANDLORD_ROLES;
  const contactRoles = deal.contactRoles.filter(contact => contactRoleTypes.includes(contact.role));

  if (contactRoles.length == 0) {
    return null;
  }

  return <ContactTooltip contactRoles={contactRoles} deal={deal} />;
}

ContactRole.propTypes = {
  deal: PropTypes.shape({
    path: PropTypes.string.isRequired,
    contactRoles: PropTypes.array
  }),
  name: PropTypes.string.isRequired,
};
